import React from "react";
import WidgetSelector from "./WidgetSelector";

export default function WidgetCostCenterSelector({
  value,
  displayValue,
  options,
  onChange,
  reloadDropdownData,
  viewOnly,
  size,
  showCloudIcon = true
}) {
  return (
    <React.Fragment>
      <WidgetSelector
        viewOnly={viewOnly || false}
        selectedValue={value}
        displayValue={displayValue}
        options={options}
        onChange={(values) => onChange(values)}
        reloadDropdownData={() => reloadDropdownData()}
        placeHolder="Select Cost Center"
        showCloudIcon={showCloudIcon}
        size={size}
      />
    </React.Fragment>
  );
}
